// extracted by mini-css-extract-plugin
export default {"skip":"skip-links-skip--60470"};